<template>
  <div class="form-field">
    <md-card-content>
      <div class="md-layout-item md-small-size-100">
       <md-field :class="messageClass('file')">
        <label v-lang.uploadFiles></label>
        <md-file ref="fileInput" id="doc-file" name="doc-file"
          v-bind:value="value" v-on:md-change="emitInput" accept="application/pdf" />
        <span class="md-error">{{ errors.file }}</span>
      </md-field>
      </div>
    </md-card-content>
  </div>
</template>

<script>
import parseBadRequest from '@/utils/parse-bad-request'
import testForErrorCode from '@/utils/test-for-err-code'
import ERRCODES from '@/utils/error-codes'

export default {
  name: 'FileFormFields',
  props: {
    value: {
      type: String | Number | null,
      required: true,
      default: null
    },
    errorMessageFile: {
      type: String
    }
  },
  computed: {
    errors () {
      return this.parseErrorMessage()
    }
  },
  watch: {
    value: {
      deep: true,
      handler (val) {
      }
    }
  },
  methods: {
    getFiles () {
      return this.$refs.fileInput.$el.querySelector('input[type=file]').files
    },
    emitInput (files) {
      this.$emit('input', files[0].name)
    },
    messageClass (field) {
      return {
        'md-invalid': this.errors[field]
      }
    },
    parseErrorMessage () {
      const errors = {}

      const errorMessages = parseBadRequest(this.errorMessageFile)
      if (errorMessages.length > 0) {
        errorMessages.forEach(errorMsg => {
          if (testForErrorCode(ERRCODES.document.fileExt, errorMsg)) {
            errors.file = this.translate('error_3_22')
          } else if (testForErrorCode(ERRCODES.document.fileSize, errorMsg)) {
            errors.file = this.translate('error_3_11')
          } else {
            this.$error(this.translate('unexpectedError'), 5000)
          }
        })
      }

      return errors
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/documents/FileFormFields.vue